/** A placeholder at the shape of the content it stands in for. Never a spinner over a page. */

import type { CSSProperties } from "react";

import { cn } from "@/lib/cn";

import { lengthOf, mergeStyle } from "../internal/style";
import "./Skeleton.css";

export interface SkeletonProps {
  readonly width?: string | number;
  readonly height?: string | number;
  readonly circle?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Skeleton({ width, height, circle, className, style }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("al-skeleton", "al-skeleton-block", className)}
      style={mergeStyle(style, {
        width: lengthOf(width),
        height: lengthOf(height),
        borderRadius: circle === true ? "var(--al-radius-full)" : undefined,
      })}
    />
  );
}
